import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  error: null,
  processInfo: null,
  summary: null,
  transactions: [],
  pagination: {
    page: 1,
    limit: 10,
    total: 0,
    total_pages: 1,
  },
  updatingStatus: false,
};

const processPayrollSlice = createSlice({
  name: "processPayroll",
  initialState,
  reducers: {
    // Get Payroll Report
    getPayrollReportStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    getPayrollReportSuccess: (state, action) => {
      state.loading = false;
      state.processInfo = action.payload.process_info;
      state.summary = action.payload.summary;
      state.transactions = action.payload.transactions || [];
      state.error = null;
    },
    getPayrollReportFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Process Monthly Payroll
    processMonthlyPayrollStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    processMonthlyPayrollSuccess: (state, action) => {
      state.loading = false;
      state.error = null;
    },
    processMonthlyPayrollFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Update Transaction Status
    updateTransactionStatusStart: (state) => {
      state.updatingStatus = true;
      state.error = null;
    },
    updateTransactionStatusSuccess: (state, action) => {
      state.updatingStatus = false;
      const index = state.transactions.findIndex(
        (transaction) => transaction.id === action.payload.id,
      );
      if (index !== -1) {
        state.transactions[index] = {
          ...state.transactions[index],
          ...action.payload,
        };
      }
      state.error = null;
    },
    updateTransactionStatusFailure: (state, action) => {
      state.updatingStatus = false;
      state.error = action.payload;
    },

    // Clear Error
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const {
  getPayrollReportStart,
  getPayrollReportSuccess,
  getPayrollReportFailure,
  processMonthlyPayrollStart,
  processMonthlyPayrollSuccess,
  processMonthlyPayrollFailure,
  updateTransactionStatusStart,
  updateTransactionStatusSuccess,
  updateTransactionStatusFailure,
  clearError,
} = processPayrollSlice.actions;

export default processPayrollSlice.reducer;
